import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { SidebarMobileButtonComponent } from './sidebar-mobile-button.component'
import { RouterModule } from '@angular/router'

@NgModule({
  imports: [CommonModule, RouterModule],
  declarations: [SidebarMobileButtonComponent],
  exports: [SidebarMobileButtonComponent],
  providers: [],
})
export class SidebarMobileButtonModule {}
